/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GTMIntertoysPurchasePayload } from "@/data/types/GTM";

export const getGAIntertoysPurchaseData = async (payload: GTMIntertoysPurchasePayload) => {

	const { products, id, revenue, tax, shipping, affiliation, checkoutBuyerEmail, coupon, settings } = payload;
	return { products, id, revenue, tax, shipping, affiliation, checkoutBuyerEmail, coupon, settings };
};
